import { formatDateForAPI } from "utils/utils";
import { getItemsFromCollection } from "directus/src/operations";

export async function fetchMonthlyTimesheet(calendarStart, calendarEnd) {
  try {
    const startDate = calendarStart;
    const endDate = calendarEnd;

    const query = {
      fields: [
        "id",
        "date",
        "logged_hours",
        "approved_hours",
        "unapproved_hours",
        "description",
        "project.id",
        "project.name",
        "job.id",
        "job.name",
        "milestone.id",
        "milestone.name",
      ],
      filter: {
        date: {
          _between: [formatDateForAPI(startDate), formatDateForAPI(endDate)],
        },
        logged_hours: {
          _gt: 0,
        },
        reviewer: {
          user: {
            _eq: "$CURRENT_USER"
          }
        },

      },
      limit: -1,
      sort: ["-date"],
    };

    const data = await getItemsFromCollection("timesheet", query);
    return data;
  } catch (error) {
    console.error("Error fetching monthly timesheet:", error);
    throw error;
  }
}
